/* eslint-disable no-unused-vars */
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Box,
    Text,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Checkbox,
    Button,
    Flex,
} from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import OrderBadge from './OrderBadge';
import { BsDownload, BsFillCreditCardFill, BsThreeDots } from 'react-icons/bs';
import FullPagination from 'components/Dashboard/FullPagination';
import 'jspdf-autotable';
import { Link } from 'react-router-dom';
import Loader from 'components/loader';
import { addCommasToNumber, getCurrencyCodeForCountry, getPriceByDate } from 'utils/utils';
import useGetUserDetails from 'hooks/useGetUserDetail';
import { useSelector } from 'react-redux';
import MakePaymentModal from 'pages/dashboard/Checkout/MakePaymentModal';
import useOrderExport from 'hooks/useOrderExport';

export default function OrdersDesktop({ isEmpty = true, list = [], orderId, loading }) {
    const [tableData, setTableData] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const userLocationReducer = useSelector((state) => state.userLocationReducer);

    const [currencyRates, setCurrencyRates] = useState({});
    const [loadingRates, setLoadingRates] = useState(false);
    const userAttrs = useGetUserDetails();
    const [isPaymentModalOpen, setPaymentModalOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);

    const currencySymbol = getCurrencyCodeForCountry(
        userLocationReducer?.location?.country_code ?? 'NG',
    );

    useEffect(() => {
        const mutatedData = list.map((order) => {
            if (order) {
                const orderDetail = JSON.parse(order.order_details);
                return {
                    ...order,
                    ...orderDetail,
                    status: order.status,
                    commission: order.commission,
                    shouldShow: !orderId || orderDetail?.entity_id?.includes(orderId),
                };
            } else {
                return null;
            }
        });
        setTableData(mutatedData);
    }, [orderId, list]);

    useEffect(() => {
        const fetchCurrencyRates = async () => {
            if (!tableData.length) return;

            setLoadingRates(true);
            const rates = {};

            try {
                // Get unique dates to avoid duplicate API calls
                const uniqueDates = [...new Set(tableData.map((order) => order.updatedAt))];

                for (const date of uniqueDates) {
                    if (date) {
                        try {
                            const rate = await getPriceByDate(date, currencySymbol);
                            rates[date] = rate;
                        } catch (error) {
                            console.error(`Error fetching rate for ${date}:`, error);
                            rates[date] = null;
                        }
                    }
                }

                setCurrencyRates(rates);
            } catch (error) {
                console.error('Error fetching currency rates:', error);
            } finally {
                setLoadingRates(false);
            }
        };

        fetchCurrencyRates();
    }, [tableData, currencySymbol]);

    const mutateTableData = (orderId) => {
        const mutatedOrders = tableData.map((order) => {
            if (order.orderId === orderId) {
                return {
                    ...order,
                    isChecked: !order.isChecked,
                };
            }
            return order;
        });
        setTableData(mutatedOrders);
    };

    const selectAll = (checked) => {
        const mutatedOrders = tableData.map((order) => {
            return {
                ...order,
                isChecked: checked,
            };
        });
        setTableData(mutatedOrders);
        setIsSelectAll(checked);
    };

    const tableFilter = useMemo(() => {
        const result = tableData?.filter((data) => data.isChecked);
        const length = result.length;
        return { result, length };
    }, [tableData]);
    console.log({tableData})
const { exportAsCSV, exportAsPDF, exportAsXLSX } = useOrderExport({tableData});

    return (
        <>
            <Box mt="5">
                <TableContainer border="1px solid #EAECF0" borderRadius="lg">
                    <Table variant="simple" size="sm">
                        <Thead>
                            <Tr>
                                <Th py="4" pr="0">
                                    <Checkbox
                                        mr="0"
                                        isChecked={isSelectAll}
                                        onChange={(e) => selectAll(e.target.checked)}
                                    />
                                </Th>

                                <Th py="4">Order Ref</Th>
                                <Th py="4">Date Ordered</Th>
                                <Th py="4">Customer Info</Th>
                                <Th py="4">Items</Th>
                                <Th py="4">Payment Status</Th>
                                <Th py="4">Order Status</Th>
                                <Th py="4">Order Value</Th>
                                <Th py="4">Shipping Cost</Th>
                                <Th py="4">Commission Payable</Th>
                                <Th py="4">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={10}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : tableData ? (
                                tableData?.map((order, i) => {
                                    console.log({ order });
                                    // Get the currency rate from state instead of calling async function
                                    const currency =
                                        order?.currency &&
                                        !order?.currency?.includes('{}') &&
                                        order?.currency?.includes('{')
                                            ? JSON.parse(order?.currency)?.symbol ??
                                              JSON.parse(order?.currency)
                                            : order?.currency && typeof order?.currency === 'string'
                                            ? order?.currency
                                            : 'USD';
                                    const currencyRate =
                                        order?.currency &&
                                        !order?.currency.includes('{}') &&
                                        order?.currency?.includes?.('rate')
                                            ? JSON.parse(order?.currency)?.rate ??
                                              JSON.parse(order?.currency)
                                            : '1';
                                    const finalCurrency =
                                        typeof currency === 'string' && currency?.includes('{')
                                            ? JSON.parse(currency)?.symbol
                                            : currency;
                                    const finalRate =
                                        isNaN(currencyRate) && currencyRate?.includes('{')
                                            ? JSON.parse(currency)?.rate
                                            : currencyRate || 1;

                                    return (
                                        <Tr fontSize="xs" key={i}>
                                            <Td py="4" pr="0">
                                                <Checkbox
                                                    mr="0"
                                                    onChange={() => mutateTableData(i)}
                                                    isChecked={order?.isChecked}
                                                />
                                            </Td>

                                            <Td
                                                py="4"
                                                textDecoration={'underline'}
                                                color="#00f"
                                                _hover={{
                                                    textDecoration: 'none',
                                                    color: 'rgba(0, 0, 255, 0.43)',
                                                }}>
                                                <Link
                                                    to={`/dashboard/order-details/${order.order_id}`}>
                                                    {order?.order_ref ?? 'N/A'}
                                                </Link>
                                            </Td>
                                            <Td py="4">
                                                <Text>
                                                    {new Date(order.createdAt).toLocaleDateString()}
                                                </Text>
                                                <Text className="transactionTime">
                                                    {new Date(order?.createdAt)
                                                        .toTimeString()
                                                        .substring(0, 8)}
                                                </Text>
                                            </Td>
                                            <Td py="4">
                                                <Text borderBottom="1px solid #EAECF0">
                                                    {JSON.parse(order?.shipment_details)
                                                        ?.delivery_address?.email ?? 'N/A'}
                                                </Text>
                                            </Td>
                                            <Td py="4" textAlign="center">
                                                {(order?.order_details &&
                                                    JSON.parse(order?.order_details)?.length) ||
                                                    'N/A'}
                                            </Td>
                                            <Td py="4">
                                                <OrderBadge
                                                    status={
                                                        order?.payments?.toUpperCase() ?? 'PENDING'
                                                    }
                                                />
                                            </Td>
                                            <Td py="4">
                                                <OrderBadge
                                                    status={
                                                        order?.status?.toUpperCase() ?? 'PENDING'
                                                    }
                                                />
                                            </Td>
                                            <Td py="4">
                                                {`${finalCurrency}  ${addCommasToNumber(
                                                    order?.amount?.toFixed(2) || '0',
                                                )}`}
                                            </Td>
                                            <Td py="4">
                                                {`${finalCurrency}  ${addCommasToNumber(
                                                    order.shipping_fee?.toFixed(2) || '0',
                                                )}`}
                                            </Td>
                                            <Td py="4">
                                                {`${finalCurrency}  ${addCommasToNumber(
                                                    order.commission?.toFixed(2) || '0',
                                                )}`}
                                            </Td>
                                            <Td py="4" textAlign="center">
                                                <Menu>
                                                    <MenuButton
                                                        as={Button}
                                                        cursor="pointer"
                                                        bg="transparent"
                                                        borderRadius="full">
                                                        <BsThreeDots />
                                                    </MenuButton>
                                                    <MenuList>
                                                        <MenuItem
                                                            icon={<BsDownload />}
                                                            onClick={() => {
                                                                console.log({ finalRate });
                                                                exportAsCSV(true, {
                                                                    ...order,
                                                                    orderAmount: `${finalCurrency}  ${addCommasToNumber(
                                                                        order?.amount?.toFixed(2) ||
                                                                            '0',
                                                                    )}`,
                                                                    orderCommission: `${finalCurrency}  ${addCommasToNumber(
                                                                        (
                                                                            order.commission *
                                                                            finalRate
                                                                        )?.toFixed(2) || '0',
                                                                    )}`,
                                                                    finalRate,
                                                                    finalCurrency,
                                                                });
                                                            }}>
                                                            Export as CSV
                                                        </MenuItem>
                                                        <MenuItem
                                                            icon={<BsDownload />}
                                                            onClick={() =>
                                                                exportAsXLSX(true, {
                                                                    ...order,
                                                                    orderAmount: `${finalCurrency}  ${addCommasToNumber(
                                                                        order?.amount?.toFixed(2) ||
                                                                            '0',
                                                                    )}`,
                                                                    orderCommission: `${finalCurrency}  ${addCommasToNumber(
                                                                        (
                                                                            order.commission *
                                                                            finalRate
                                                                        )?.toFixed(2) || '0',
                                                                    )}`,
                                                                    finalRate,
                                                                    finalCurrency,
                                                                })
                                                            }>
                                                            Export as XLSX
                                                        </MenuItem>
                                                        <MenuItem
                                                            icon={<BsDownload />}
                                                            onClick={() =>
                                                                exportAsPDF(true, {
                                                                    ...order,
                                                                    orderAmount: `${finalCurrency}  ${addCommasToNumber(
                                                                        order?.amount?.toFixed(2) ||
                                                                            '0',
                                                                    )}`,
                                                                    orderCommission: `${finalCurrency}  ${addCommasToNumber(
                                                                        (
                                                                            order.commission *
                                                                            finalRate
                                                                        )?.toFixed(2) || '0',
                                                                    )}`,
                                                                    finalRate,
                                                                    finalCurrency,
                                                                })
                                                            }>
                                                            Export as PDF
                                                        </MenuItem>
                                                        <MenuItem
                                                            icon={<BsFillCreditCardFill />}
                                                            onClick={() => {
                                                                setSelectedOrder(order);
                                                                setPaymentModalOpen(true);
                                                            }}>
                                                            Make Payment
                                                        </MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <Tr>You have not placed any Orders yet</Tr>
                            )}
                        </Tbody>
                    </Table>
                    {tableFilter.length || isSelectAll ? (
                        <Flex
                            px="10"
                            alignItems="center"
                            fontSize="sm"
                            fontWeight="medium"
                            w="full"
                            py="4"
                            justifyContent="space-between">
                            <Flex alignItems="center" gap="3">
                                <Text>{tableFilter.length} selected</Text>
                                <Button
                                    onClick={() => selectAll(false)}
                                    isDisabled={!tableFilter.length}>
                                    Deselect
                                </Button>
                            </Flex>
                            <Flex gap="3">
                                <Button
                                    bg="#FFF0F0"
                                    leftIcon={<BsDownload />}
                                    color="#000"
                                    variant="outline"
                                    fontWeight="400"
                                    onClick={() => exportAsCSV(false)}>
                                    Export as CSV
                                </Button>
                                <Button
                                    bg="#FFF0F0"
                                    leftIcon={<BsDownload />}
                                    color="#000"
                                    variant="outline"
                                    fontWeight="400"
                                    onClick={() => exportAsXLSX(false)}>
                                    Export as XLSX
                                </Button>
                                {/* <Button
                                    leftIcon={<BsDownload />}
                                    bg="#1b3b5f"
                                    color="#fff"
                                    _hover={{
                                        bg: '#fff',
                                        color: '#1b3b5f',
                                        border: '1px solid #1b3b5f',
                                    }}
                                    fontWeight="400"
                                    onClick={() => exportAsPDF(false)}>
                                    Export as PDF
                                </Button> */}
                            </Flex>
                        </Flex>
                    ) : (
                        <FullPagination handlePageClick={() => null} fullData={tableData} />
                    )}
                </TableContainer>
            </Box>
            <MakePaymentModal
                isOpen={isPaymentModalOpen}
                closeModal={() => setPaymentModalOpen(false)}
                orderDetails={selectedOrder}
            />
        </>
    );
}

export const getCurrencyAndRate = (order) => {
    const currency =
        order?.currency && !order?.currency?.includes('{}') && order?.currency?.includes('{')
            ? JSON.parse(order?.currency)?.symbol ?? JSON.parse(order?.currency)
            : order?.currency && typeof order?.currency === 'string'
            ? order?.currency
            : 'USD';
    const currencyRate =
        order?.currency && !order?.currency.includes('{}') && order?.currency?.includes?.('rate')
            ? JSON.parse(order?.currency)?.rate ?? JSON.parse(order?.currency)
            : '1';
    const finalCurrency =
        typeof currency === 'string' && currency?.includes('{')
            ? JSON.parse(currency)?.symbol
            : currency;
    const finalRate =
        isNaN(currencyRate) && currencyRate?.includes('{')
            ? JSON.parse(currencyRate)
            : currencyRate || 1;
    return { finalCurrency, finalRate };
};
